module.exports = __webpack_public_path__ + "img/public/SiteIcons/lightPlusIcon.svg?275aafaa";